import type { ReactNode } from 'react';

interface Props {
  marcada: boolean;
  onCambio: (marcada: boolean) => void;
  children: ReactNode;
  disabled?: boolean;
}

/**
 * Casilla de confirmación, por ejemplo "Entiendo el riesgo".
 *
 * Toda la fila es tocable y mide al menos 44 puntos (Req. 8.1). Se usa en las
 * confirmaciones reforzadas, donde marcar la casilla es la confirmación.
 */
export function Casilla({ marcada, onCambio, children, disabled = false }: Props) {
  return (
    <label
      className={[
        'flex min-h-11 cursor-pointer items-start gap-3 rounded-[13px] border px-3 py-3 text-[13px] leading-relaxed text-texto',
        marcada ? 'border-marca bg-marca-suave' : 'border-borde-fuerte bg-superficie',
        disabled ? 'cursor-not-allowed opacity-70' : '',
      ].join(' ')}
    >
      <input
        type="checkbox"
        checked={marcada}
        disabled={disabled}
        onChange={(e) => onCambio(e.target.checked)}
        className="mt-0.5 size-5 shrink-0 accent-[var(--color-marca)]"
      />
      <span>{children}</span>
    </label>
  );
}
